module.exports = __webpack_public_path__ + "img/kate_macK210964.e49a96af.jpg";